import dynamic from "next/dynamic";

const Templates = {
  Currencies: dynamic(() => import("./Currencies")),
  CurrenciesBonds: dynamic(() => import("./CurrenciesBonds")),
  Bonds: dynamic(() => import("./Bonds")),
  BonusCalculator: dynamic(() => import("./BonusCalculator")),
  DailyHoroscope: dynamic(() => import("./Horoscope/DailyHoroscope")),
  TomorrowHoroscope: dynamic(() => import("./Horoscope/TomorrowHoroscope")),
  HowIsHoroscope: dynamic(() => import("./Horoscope/HowIsHoroscope")),
  DailyHoroscopeLanding: dynamic(() => import("./Horoscope/DailyHoroscopeLanding")),
  TomorrowHoroscopeLanding: dynamic(() => import("./Horoscope/TomorrowHoroscopeLanding")),
  HowIsHoroscopeLanding: dynamic(() => import("./Horoscope/HowIsHoroscopeLanding")),
  YearPredictionsZodiacLanding: dynamic(() => import("./Horoscope/YearPredictionsZodiacLanding")),
  YearPredictionsZodiac: dynamic(() => import("./Horoscope/YearPredictionsZodiac")),
  Dialogues: dynamic(() => import("./Dialogues")),
  FrequentlyAskedQuestions: dynamic(() => import("./FrequentlyAskedQuestions")),
  Games: dynamic(() => import("./Games")),
  GridGame: dynamic(() => import("./GridGame")),
  HolidayPublic: dynamic(() => import("./HolidayPublic")),
  IncomeTaxCalculator: dynamic(() => import("./IncomeTaxCalculator")),
  Lottery: dynamic(() => import("./Lottery")),
  LotteryDreams: dynamic(() => import("./LotteryDreams")),
  LotteryGame: dynamic(() => import("./LotteryGame")),
  LotteryQuiniela: dynamic(() => import("./LotteryQuiniela")),
  Newsletter: dynamic(() => import("./Newsletter")),
  NewsletterDescription: dynamic(() => import("./NewsletterDescription")),
  RadioLive: dynamic(() => import("./RadioLive")),
  RuralWeather: dynamic(() => import("./RuralWeather")),
  Searcher: dynamic(() => import("./Searcher")),
  SportsCalendar: dynamic(() => import("./SportsCalendar")),
  SportsStatics: dynamic(() => import("./SportsStatics")),
  Tags: dynamic(() => import("./Tags")),
  VideoDocumentary: dynamic(() => import("./VideoDocumentary")),
  Weather: dynamic(() => import("./Weather")),
  WeatherCity: dynamic(() => import("./WeatherCity")),
  Astrology: dynamic(() => import("./Astrology")),
  Compatibility: dynamic(() => import("./Astrology/components/Compatibility")),
  Humor: dynamic(() => import("./Humor")),
  LandingApp: dynamic(() => import("./LandingApp")),
  SiteMap: dynamic(() => import("./SiteMap")),
  TermsConditions: dynamic(() => import("./TermsConditions")),
  Rss: dynamic(() => import("./Rss")),
  Movil: dynamic(() => import("./Movil")),
  PaymentCalculation: dynamic (() => import("./PaymentCalculation")),
  PanamericanGames: dynamic (() => import("./PanamericanGames")),
  LandingEMQV: dynamic (() => import("./LandingEMQV")),
  LandingDemocraciayDesarrollo: dynamic (() => import("./LandingDemocraciayDesarrollo")),
  CorporateLanding: dynamic (() => import("./CorporateLanding")),
  AudioNews: dynamic (() => import("./AudioNews")) ,
  AudioPlaylist: dynamic (() => import("./AudioPlaylist")) ,
  AudioSinglePlay: dynamic (() => import("./AudioSinglePlay")),
  Olympics: dynamic (() => import("./Olympics")),
  MedalTable: dynamic (() => import("./Olympics/MedalTable")),
  CoverAgenda: dynamic (() => import("./Olympics/CoverAgenda")),
  Podium: dynamic (() => import("./Olympics/Podium")),
  Records: dynamic (() => import("./Olympics/Records")),
  Soccer: dynamic (() => import("./Olympics/Soccer")),
  SingleTaxCalculator: dynamic(() => import("./SingleTaxCalculator")),
  CalculatorRentals: dynamic(() => import("./CalculatorRentals")),
};

export default Templates;